<template>
    <v-layout column fill-height>
        <breadcrumbs v-on:selectTab="changeTab" :guia="guia" titulo="Informes Fiscais" descricao="Gerencie, acompanhe e informe notas fiscais, alíquotas e rendimentos." :tabs="tabOptions" />
        <!-- <breadcrumbs v-on:selectTab="changeTab" :guia="guia" titulo="Informes Fiscais" descricao="Corretor, estamos passando por atualizações nos dados de Recibos Pagos e Informes fiscais. Prazo para regularização 22/01/20." :tabs="tabOptions" /> -->
        <v-layout class="main overflow-y-auto">
           <v-flex v-if="tab == 1">
                <emissaoDeNotas />
            </v-flex>
           <v-flex v-if="tab == 2">
                <notasSubmetidas />
            </v-flex>
           <v-flex v-if="tab == 3">
            <simplesNacional />
            </v-flex>
           <v-flex v-if="tab == 4">
                <v-layout row class="content-header">
                    <v-flex md12 class="content-title">
                        <h2>Informe de Rendimentos</h2>
                        <h4>Consulte informes de rendimentos do ano base no qual tiveram retenções de impostos.</h4>
                    </v-flex>
                </v-layout>
                <v-layout row class="content-body overflow-y-auto">
                    <v-flex md12>
                        <rendimentos />
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <!-- alerta urgente -->
            <v-dialog v-model="showDialogAlertaUrgente" max-width="605px" style="height:910px;">
              <v-card class="text-white" style="height: 903px; background: url('/upload/comunicado_mudanca_CNPJ.png') center center; background-size: auto; background-repeat: no-repeat; background-size: cover;" outlined>
              </v-card>      
            </v-dialog>           
    </v-layout>
</template>


<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex';

import breadcrumbs from "@/components/portal/layout/Breadcrumbs";

import emissaoDeNotas from "@/components/portal/informes-fiscais/EmissaoDeNotas";
import notasSubmetidas from "@/components/portal/informes-fiscais/NotasSubmetidas";
import simplesNacional from "@/components/portal/informes-fiscais/SimplesNacional";
import rendimentos from "@/components/portal/informes-fiscais/Rendimentos";

export default {
  components: {
    breadcrumbs,
    emissaoDeNotas,
    notasSubmetidas,
    simplesNacional,
    rendimentos
  },
  data() {
      return {
        tab:1,
        guia: "Informes fiscais > Emissão de notas",
        tabOptions: [
            { id: 1, titulo: "Emissão de Notas"},
            { id: 2, titulo: "Notas Submetidas"},
            { id: 3, titulo: "Simples Nacional"},
            { id: 4, titulo: "Rendimentos"},
        ],
        showDialogAlertaUrgente: true      
      }
  },
  methods: {
      changeTab(value){
          this.tab = value;
          this.guia = "Informes fiscais > " + this.tabOptions[value - 1].titulo;
      },
  },
    watch: {
        
    },        
    computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
    },
    mounted(){            
    },  
};
</script>